import listener from '@mailobj-browser/front/js/events/listeners/listener.js'
import input from '@mailobj-browser/front/js/events/types/input.js'
import passive from '@mailobj-browser/front/js/events/options/passive.js'
import one from '@mailobj-browser/front/js/selectors/one.js'
import removed from '@mailobj-browser/front/js/tree/removed.js'
import object from '@mailobj-browser/front/js/utils/object.js'
import { elements } from '../xfiles/styles.js'

const handlers = new WeakMap()
const lists = new WeakMap()

const onInput = object(listener, {
  type: input,
  passive,
  task: (uploader, { target }) => {
    return handlers.get(target)?.(target, lists.get(uploader))
  }
})

export const handle = (input, handler) => {
  handlers.set(input, handler)
}

export default uploader => {
  lists.set(uploader, one(`.${elements.xfiles_uploads}`, uploader))
  onInput.listen(uploader)
  
  queueMicrotask(async () => {
    await removed(uploader)
    lists.delete(uploader)
  })
}
